<template>
  <form class="ovg-form" @submit.prevent="onSubmit">
    <div class="ovg-row">
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-servicio">Tipo de Servicio</label>
        <select
          id="input-servicio"
          v-model="formWarranty.tipo_servicio"
          class="ovg-select"
          :class="{
            'ovg-select--error':
              $v.formWarranty.tipo_servicio.$dirty &&
              $v.formWarranty.tipo_servicio.$invalid,
          }"
          @change="$v.formWarranty.tipo_servicio.$touch()"
        >
          <option
            v-for="opt in serviceOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
        <p
          v-if="
            $v.formWarranty.tipo_servicio.$dirty &&
            !$v.formWarranty.tipo_servicio.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
    </div>

    <div v-show="esGarantia" class="ovg-row">
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-fecha">Fecha de Compra</label>
        <b-form-datepicker
          id="input-fecha"
          v-model="formWarranty.fecha_de_compra"
          class="ovg-datepicker"
          :class="{
            'ovg-datepicker--error':
              $v.formWarranty.fecha_de_compra.$dirty &&
              $v.formWarranty.fecha_de_compra.$invalid,
          }"
          placeholder="Selecciona"
          select-variant="primary"
          @input="$v.formWarranty.fecha_de_compra.$touch()"
        />
        <p
          v-if="
            $v.formWarranty.fecha_de_compra.$dirty &&
            !$v.formWarranty.fecha_de_compra.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field">
        <label class="ovg-label" for="input-falla"
          >Describe el problema de tu equipo</label
        >
        <textarea
          id="input-falla"
          v-model="formWarranty.reporte_falla_cliente"
          class="ovg-textarea"
          :class="{
            'ovg-textarea--error':
              $v.formWarranty.reporte_falla_cliente.$dirty &&
              $v.formWarranty.reporte_falla_cliente.$invalid,
          }"
          placeholder="Ej: El equipo no enciende al presionar el botón, la pantalla parpadea, la batería no carga, etc. Detalla lo más posible para ayudar a nuestros técnicos."
          @blur="$v.formWarranty.reporte_falla_cliente.$touch()"
        />
        <p
          v-if="
            $v.formWarranty.reporte_falla_cliente.$dirty &&
            !$v.formWarranty.reporte_falla_cliente.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
    </div>

    <div v-show="esGarantia" class="ovg-upload">
      <label class="ovg-label">Comprobante de Compra (Boleta o Factura)*</label>
      <UploadFilePreIngreso :setBoleta="setBoleta" :boleta="boletaLocal" />
      <p
        v-if="$v.boletaLocal.$dirty && !$v.boletaLocal.required"
        class="ovg-error"
      >
        Campo requerido
      </p>
    </div>

    <div class="ovg-card__footer ovg-card__footer--between">
      <button type="button" class="ovg-btn ovg-btn--secondary" @click="goBack">
        Paso Anterior
      </button>
      <button
        type="submit"
        class="ovg-btn ovg-btn--primary"
        :disabled="loading"
      >
        Siguiente Paso
      </button>
    </div>
  </form>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import UploadFilePreIngreso from '../Form/UploadFilePreIngreso.vue'
import {
  TIPO_SERVICIO_GARANTIA,
  TIPO_SERVICIO_PRESUPUESTO,
} from './consentimiento'

const desdeRetorno = (garantia) => ({
  tipo_servicio: garantia.tipo_servicio || null,
  reporte_falla_cliente: garantia.reporte_falla_cliente || '',
  fecha_de_compra: garantia.fecha_de_compra || null,
})

export default {
  name: 'WarrantyFailsRegions',
  components: {
    UploadFilePreIngreso,
  },
  props: ['setDataWarranty', 'warrantyReturn', 'boleta', 'loading'],
  data() {
    return {
      formWarranty: desdeRetorno(this.warrantyReturn),
      boletaLocal: this.boleta || '',
      serviceOptions: [
        { value: null, text: 'Selecciona' },
        { value: TIPO_SERVICIO_GARANTIA, text: 'Garantía' },
        { value: TIPO_SERVICIO_PRESUPUESTO, text: 'Presupuesto' },
      ],
    }
  },
  validations: {
    formWarranty: {
      tipo_servicio: { required },
      reporte_falla_cliente: {
        required: requiredIf(function f() {
          return [TIPO_SERVICIO_GARANTIA, TIPO_SERVICIO_PRESUPUESTO].includes(
            this.formWarranty.tipo_servicio
          )
        }),
      },
      fecha_de_compra: {
        required: requiredIf(function f() {
          return this.esGarantia
        }),
      },
    },
    boletaLocal: {
      required: requiredIf(function f() {
        return this.esGarantia
      }),
    },
  },
  computed: {
    esGarantia() {
      return this.formWarranty.tipo_servicio === TIPO_SERVICIO_GARANTIA
    },
  },
  watch: {
    warrantyReturn: {
      handler() {
        this.formWarranty = desdeRetorno(this.warrantyReturn)
      },
      deep: true,
    },
    boleta(val) {
      this.boletaLocal = val || ''
    },
  },
  methods: {
    onSubmit() {
      if (this.$v.$invalid) {
        this.$bvToast.toast('Rellene todos los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else {
        this.setDataWarranty({ ...this.formWarranty }, this.boletaLocal)
      }
    },
    setBoleta(boleta) {
      this.boletaLocal = boleta
      this.$v.boletaLocal.$touch()
    },
    goBack() {
      this.$emit('goBack')
    },
  },
}
</script>
